export const Envs = {
  ENVIRONMENT: process.env['ENVIRONMENT'],
  SITE_URL: process.env['NX_SITE_URL'] ?? process.env['REACT_APP_SITE_URL'],
  COOKIE_DOMAIN:
    process.env['NX_COOKIE_DOMAIN'] ??
    process.env['REACT_APP_COOKIE_DOMAIN'] ??
    process.env['NEXT_PUBLIC_COOKIE_DOMAIN'],
  PAY_CHECKOUT_URL: process.env['NX_PAY_URL'] ?? process.env['REACT_APP_PAY_CHECKOUT_URL'],
}
